// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.v1.conversation.SatelliteWebConversationHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebDeleteAttachmentsRequestDto,
  SatelliteWebGetDocumentUploadTokenResponseDto,
  SatelliteWebZdocIdsForMessageTokensRequestDto,
  SatelliteWebZdocIdsForMessageTokensResponseDto,
} from '../..';

export const SatelliteWebConversationHandler_deleteAttachments_Path = '/api/web/v1/conversation/deleteAttachments';

export const SatelliteWebConversationHandler_deleteAttachments = (
  postData: SatelliteWebDeleteAttachmentsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebDeleteAttachmentsRequestDto, void>(
    {
      endpoint: SatelliteWebConversationHandler_deleteAttachments_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebConversationHandler_getDocumentUploadToken_Path =
  '/api/web/v1/conversation/getDocumentUploadToken';

export const SatelliteWebConversationHandler_getDocumentUploadToken = (client = getClient()) => {
  return httpFrontEndRequest<never, never, SatelliteWebGetDocumentUploadTokenResponseDto>(
    {
      endpoint: SatelliteWebConversationHandler_getDocumentUploadToken_Path,
      method: 'GET',
      contextPath: '/satellite',
    },
    client,
  );
};

export const SatelliteWebConversationHandler_getZdocIdsForMessageTokens_Path =
  '/api/web/v1/conversation/getZdocIdsForMessageTokens';

export const SatelliteWebConversationHandler_getZdocIdsForMessageTokens = (
  postData: SatelliteWebZdocIdsForMessageTokensRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebZdocIdsForMessageTokensRequestDto,
    SatelliteWebZdocIdsForMessageTokensResponseDto
  >(
    {
      endpoint: SatelliteWebConversationHandler_getZdocIdsForMessageTokens_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
